export function getReasonsLabels(reason, translationPrefix, translationFn) {
  if (!reason) {
    return null;
  }

  return reason?.map(reasonItem =>
    translationFn({
      key: `${translationPrefix}.${reasonItem}`,
      fallBack: reasonItem
    })
  );
}
